<!-- 下拉菜单 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1">内容设置</MenuItem>
                <MenuItem name="2">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="left"
                        :label-width="80"
                    >
                        <div class="form-title">预设类型</div>
                        <FormItem label="字段属性">
                            <RadioGroup
                                v-model="newFormData.content.field_attribute"
                            >
                                <Radio class="mr24" label="1">必填</Radio>
                                <Radio class="mr24" label="2">不必填</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="编辑选项">
                            <Button type="warning" ghost @click="goEdit"
                                >预设编辑</Button
                            >
                        </FormItem>
                        <div class="form-title">选择样式</div>
                        <FormItem label="选择样式">
                            <div class="flex-sb">
                                <div
                                    :class="
                                        newFormData.content.select_style == 1
                                            ? 'nav-active'
                                            : 'nav'
                                    "
                                    @click="changeNav(1)"
                                >
                                    <img
                                        v-if="
                                            newFormData.content.select_style ==
                                            1
                                        "
                                        src="@/assets/controlPanel/selectStyle/style1-active.png"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/controlPanel/selectStyle/style1.png"
                                    />
                                    <span>样式一</span>
                                </div>
                                <div
                                    :class="
                                        newFormData.content.select_style == 2
                                            ? 'nav-active'
                                            : 'nav'
                                    "
                                    @click="changeNav(2)"
                                >
                                    <img
                                        v-if="
                                            newFormData.content.select_style ==
                                            2
                                        "
                                        src="@/assets/controlPanel/selectStyle/style2-active.png"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/controlPanel/selectStyle/style2.png"
                                    />
                                    <span>样式二</span>
                                </div>
                                <div
                                    :class="
                                        newFormData.content.select_style == 3
                                            ? 'nav-active'
                                            : 'nav'
                                    "
                                    @click="changeNav(3)"
                                >
                                    <img
                                        v-if="
                                            newFormData.content.select_style ==
                                            3
                                        "
                                        src="@/assets/controlPanel/selectStyle/style3-active.png"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/controlPanel/selectStyle/style3.png"
                                    />
                                    <span>样式三</span>
                                </div>
                            </div>
                        </FormItem>
                        <div class="form-title">标题设置</div>
                        <FormItem label="内容标题">
                            <Input
                                v-model="newFormData.content.title"
                                placeholder="请输入内容标题"
                            ></Input>
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_color"
                            />
                        </FormItem>
                        <FormItem label="边框颜色">
                            <ColorPicker
                                v-model="newFormData.content.border_color"
                            />
                        </FormItem>
                        <FormItem
                            v-if="
                                newFormData.content.select_style == 2 ||
                                newFormData.content.select_style == 3
                            "
                            label="填充颜色"
                        >
                            <ColorPicker
                                v-model="newFormData.content.fill_color"
                            />
                        </FormItem>
                        <div class="form-title">提示/输入文字</div>
                        <FormItem label="提示文本">
                            <ColorPicker
                                v-model="newFormData.content.prompt_text_color"
                            />
                        </FormItem>
                        <FormItem label="输入文本">
                            <ColorPicker
                                v-model="newFormData.content.enter_text_color"
                            />
                        </FormItem>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div v-if="name_id == 2">
                <Form
                    :model="newFormData"
                    label-position="right"
                    :label-width="80"
                >
                    <div class="form-title">外间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.outer_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.outer_spacing.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.outer_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.outer_spacing.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">内间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.inner_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.inner_spacing.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.inner_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.inner_spacing.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">圆角设置</div>
                    <FormItem label="上圆角"
                        ><Slider
                            v-if="newFormData.content.rounded_corner_setting"
                            class="w300"
                            show-input
                            v-model="
                                newFormData.content.rounded_corner_setting.top
                            "
                        ></Slider
                    ></FormItem>
                    <FormItem label="下圆角"
                        ><Slider
                            v-if="newFormData.content.rounded_corner_setting"
                            class="w300"
                            show-input
                            v-model="
                                newFormData.content.rounded_corner_setting
                                    .bottom
                            "
                        ></Slider
                    ></FormItem>
                </Form>
            </div>
        </div>
        <!-- 编辑选项 -->
        <Modal
            v-model="edit_modal"
            title="编辑选项"
            width="700"
            :mask-closable="false"
        >
            <div class="cascade-box">
                <!-- 一级 -->
                <div class="cascade-col">
                    <div class="cascade-title">一级</div>
                    <div class="cascade-list">
                        <div
                            v-for="(item, index) in option_list"
                            :key="'l1-' + index"
                            class="cascade-item"
                            :class="{ active: activeLevel1 === index }"
                            @click="selectLevel1(index)"
                        >
                            <Input
                                ref="cascadeInput"
                                v-if="editRow === 'l1-' + index"
                                class="cascade-input"
                                v-model="editText"
                                size="small"
                                @click.stop
                                @on-enter="saveEdit"
                                @on-blur="saveEdit"
                            />
                            <template v-else>
                                <span class="cascade-text">{{
                                    item.name || "未命名"
                                }}</span>
                                <span class="cascade-actions">
                                    <Icon
                                        type="md-create"
                                        class="cascade-icon"
                                        @click.stop="editLevel1(index)"
                                    />
                                    <Icon
                                        type="ios-close-circle"
                                        class="cascade-icon danger"
                                        @click.stop="delLevel1(index)"
                                    />
                                </span>
                            </template>
                        </div>
                        <div v-if="!option_list.length" class="cascade-empty">
                            暂无选项
                        </div>
                    </div>
                    <div class="cascade-add" @click="addLevel1">
                        <Icon type="md-add" size="18" color="#FF761D" />
                        <span>添加</span>
                    </div>
                </div>
                <!-- 二级 -->
                <div class="cascade-col">
                    <div class="cascade-title">二级</div>
                    <div class="cascade-list">
                        <div
                            v-for="(item, index) in level2List"
                            :key="'l2-' + index"
                            class="cascade-item"
                            :class="{ active: activeLevel2 === index }"
                            @click="selectLevel2(index)"
                        >
                            <Input
                                ref="cascadeInput"
                                v-if="editRow === 'l2-' + index"
                                class="cascade-input"
                                v-model="editText"
                                size="small"
                                @click.stop
                                @on-enter="saveEdit"
                                @on-blur="saveEdit"
                            />
                            <template v-else>
                                <span class="cascade-text">{{
                                    item.name || "未命名"
                                }}</span>
                                <span class="cascade-actions">
                                    <Icon
                                        type="md-create"
                                        class="cascade-icon"
                                        @click.stop="editLevel2(index)"
                                    />
                                    <Icon
                                        type="ios-close-circle"
                                        class="cascade-icon danger"
                                        @click.stop="delLevel2(index)"
                                    />
                                </span>
                            </template>
                        </div>
                        <div v-if="activeLevel1 === -1" class="cascade-empty">
                            请先选择一级
                        </div>
                        <div
                            v-else-if="!level2List.length"
                            class="cascade-empty"
                        >
                            暂无选项
                        </div>
                    </div>
                    <div
                        class="cascade-add"
                        :class="{ disabled: activeLevel1 === -1 }"
                        @click="addLevel2"
                    >
                        <Icon
                            type="md-add"
                            size="18"
                            :color="activeLevel1 === -1 ? '#ccc' : '#FF761D'"
                        />
                        <span>添加</span>
                    </div>
                </div>
                <!-- 三级 -->
                <div class="cascade-col">
                    <div class="cascade-title">三级</div>
                    <div class="cascade-list">
                        <div
                            v-for="(item, index) in level3List"
                            :key="'l3-' + index"
                            class="cascade-item"
                        >
                            <Input
                                ref="cascadeInput"
                                v-if="editRow === 'l3-' + index"
                                class="cascade-input"
                                v-model="editText"
                                size="small"
                                @click.stop
                                @on-enter="saveEdit"
                                @on-blur="saveEdit"
                            />
                            <template v-else>
                                <span class="cascade-text">{{
                                    item.name || "未命名"
                                }}</span>
                                <span class="cascade-actions">
                                    <Icon
                                        type="md-create"
                                        class="cascade-icon"
                                        @click.stop="editLevel3(index)"
                                    />
                                    <Icon
                                        type="ios-close-circle"
                                        class="cascade-icon danger"
                                        @click.stop="delLevel3(index)"
                                    />
                                </span>
                            </template>
                        </div>
                        <div v-if="activeLevel2 === -1" class="cascade-empty">
                            请先选择二级
                        </div>
                        <div
                            v-else-if="!level3List.length"
                            class="cascade-empty"
                        >
                            暂无选项
                        </div>
                    </div>
                    <div
                        class="cascade-add"
                        :class="{ disabled: activeLevel2 === -1 }"
                        @click="addLevel3"
                    >
                        <Icon
                            type="md-add"
                            size="18"
                            :color="activeLevel2 === -1 ? '#ccc' : '#FF761D'"
                        />
                        <span>添加</span>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            edit_modal: false,
            // 三级级联编辑数据
            option_list: [],
            activeLevel1: -1,
            activeLevel2: -1,
            editRow: null,
            editText: "",
        };
    },
    mounted() {},
    computed: {
        // 二级列表：依赖选中的一级
        level2List() {
            if (this.activeLevel1 === -1) return [];
            const l1 = this.option_list[this.activeLevel1];
            return (l1 && l1.children) || [];
        },
        // 三级列表：依赖选中的二级
        level3List() {
            if (this.activeLevel1 === -1 || this.activeLevel2 === -1) {
                return [];
            }
            const l2 = this.level2List[this.activeLevel2];
            return (l2 && l2.children) || [];
        },
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        changeNav(i) {
            this.newFormData.content.select_style = i;
        },
        goEdit() {
            this.initOptionList();
            this.edit_modal = true;
        },
        cancelModal() {
            this.edit_modal = false;
            this.editRow = null;
            this.editText = "";
        },
        submitModal() {
            console.log("submitModal", this.option_list);
            this.newFormData.content.option_list = JSON.parse(
                JSON.stringify(this.option_list)
            );
            this.edit_modal = false;
            this.editRow = null;
            this.editText = "";
        },
        // 回显回填：深拷贝 + 规范化 + 定位到第一个一级/二级
        initOptionList() {
            const raw = JSON.parse(
                JSON.stringify(this.newFormData.content.option_list || [])
            );
            raw.forEach((l1) => {
                if (!Array.isArray(l1.children)) {
                    l1.children = [];
                }
                l1.children.forEach((l2) => {
                    if (!Array.isArray(l2.children)) {
                        l2.children = [];
                    }
                });
            });
            this.option_list = raw;
            this.activeLevel1 = this.option_list.length ? 0 : -1;
            this.activeLevel2 =
                this.activeLevel1 !== -1 && this.level2List.length ? 0 : -1;
            this.editRow = null;
            this.editText = "";
        },
        // 选择一级：刷新二级，并清空二级、三级选中状态
        selectLevel1(index) {
            // 编辑态下不响应行点击，避免输入框被误清空
            if (this.editRow) return;
            this.activeLevel1 = index;
            this.activeLevel2 = -1;
            this.editRow = null;
            this.editText = "";
        },
        // 选择二级：刷新三级，并清空三级选中状态
        selectLevel2(index) {
            if (this.editRow) return;
            this.activeLevel2 = index;
            this.editRow = null;
            this.editText = "";
        },
        // 新增一级
        addLevel1() {
            this.option_list.push({ name: "", children: [] });
            this.activeLevel1 = this.option_list.length - 1;
            this.activeLevel2 = -1;
            this.editRow = "l1-" + this.activeLevel1;
            this.editText = "";
            this.focusEditInput();
        },
        // 新增二级（需先选中一级）
        addLevel2() {
            if (this.activeLevel1 === -1) return;
            const l1 = this.option_list[this.activeLevel1];
            if (!Array.isArray(l1.children)) {
                this.$set(l1, "children", []);
            }
            l1.children.push({ name: "", children: [] });
            this.activeLevel2 = l1.children.length - 1;
            this.editRow = "l2-" + this.activeLevel2;
            this.editText = "";
            this.focusEditInput();
        },
        // 新增三级（需先选中二级）
        addLevel3() {
            if (this.activeLevel1 === -1 || this.activeLevel2 === -1) return;
            const l2 =
                this.option_list[this.activeLevel1].children[this.activeLevel2];
            if (!Array.isArray(l2.children)) {
                this.$set(l2, "children", []);
            }
            l2.children.push({ name: "" });
            this.editRow = null;
            this.editText = "";
        },
        // 编辑一级文字
        editLevel1(index) {
            this.editRow = "l1-" + index;
            this.editText = this.option_list[index].name || "";
            this.focusEditInput();
        },
        // 编辑二级文字
        editLevel2(index) {
            this.editRow = "l2-" + index;
            this.editText = this.level2List[index].name || "";
            this.focusEditInput();
        },
        // 编辑三级文字
        editLevel3(index) {
            this.editRow = "l3-" + index;
            this.editText = this.level3List[index].name || "";
            this.focusEditInput();
        },
        // 保存编辑
        saveEdit() {
            if (!this.editRow) return;
            const parts = this.editRow.split("-");
            const level = parts[0];
            const index = Number(parts[1]);
            if (level === "l1" && this.option_list[index]) {
                this.option_list[index].name = this.editText;
            } else if (
                level === "l2" &&
                this.activeLevel1 !== -1 &&
                this.level2List[index]
            ) {
                this.level2List[index].name = this.editText;
            } else if (
                level === "l3" &&
                this.activeLevel2 !== -1 &&
                this.level3List[index]
            ) {
                this.level3List[index].name = this.editText;
            }
            this.editRow = null;
            this.editText = "";
        },
        // 删除一级：连带删除其下所有二级、三级
        delLevel1(index) {
            this.option_list.splice(index, 1);
            if (this.activeLevel1 === index) {
                this.activeLevel1 = -1;
                this.activeLevel2 = -1;
            } else if (this.activeLevel1 > index) {
                this.activeLevel1 -= 1;
            }
            this.editRow = null;
            this.editText = "";
        },
        // 删除二级：连带删除其下所有三级
        delLevel2(index) {
            if (this.activeLevel1 === -1) return;
            const l1 = this.option_list[this.activeLevel1];
            if (!Array.isArray(l1.children)) return;
            l1.children.splice(index, 1);
            if (this.activeLevel2 === index) {
                this.activeLevel2 = -1;
            } else if (this.activeLevel2 > index) {
                this.activeLevel2 -= 1;
            }
            this.editRow = null;
            this.editText = "";
        },
        // 删除三级
        delLevel3(index) {
            if (this.activeLevel1 === -1 || this.activeLevel2 === -1) return;
            const l2 =
                this.option_list[this.activeLevel1].children[this.activeLevel2];
            if (!Array.isArray(l2.children)) return;
            l2.children.splice(index, 1);
            this.editRow = null;
            this.editText = "";
        },
        // 聚焦到编辑输入框
        focusEditInput() {
            this.$nextTick(() => {
                const input = this.$refs.cascadeInput;
                if (Array.isArray(input)) {
                    if (input[0] && input[0].focus) {
                        input[0].focus();
                    }
                } else if (input && input.focus) {
                    input.focus();
                }
            });
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: #ff761d;
    color: #ff761d;
    box-shadow: -1px 0 0 0 #ff761d;
}
::v-deep .ivu-radio-group-button :hover {
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.nav {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.nav-active {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ff761d;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #ff761d;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
/* 三级级联编辑弹窗 */
.cascade-box {
    display: flex;
    height: 380px;
    border: 1px solid #e8eaec;
    border-radius: 4px;
    overflow: hidden;
}
.cascade-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e8eaec;
}
.cascade-col:last-child {
    border-right: none;
}
.cascade-title {
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: bold;
    font-size: 14px;
    color: #484e66;
    background: #f8f8f9;
    border-bottom: 1px solid #e8eaec;
}
.cascade-list {
    flex: 1;
    overflow-y: auto;
    padding: 4px 0;
}
.cascade-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #484e66;
}
.cascade-item:hover {
    background: #f5f7fa;
}
.cascade-item.active {
    background: #fff4ec;
    color: #ff761d;
}
.cascade-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cascade-actions {
    display: none;
    align-items: center;
}
.cascade-item:hover .cascade-actions {
    display: flex;
}
.cascade-icon {
    margin-left: 8px;
    font-size: 16px;
    color: #ff761d;
    cursor: pointer;
}
.cascade-icon.danger {
    color: #ed4014;
}
.cascade-input {
    width: 100%;
}
.cascade-empty {
    padding: 16px 12px;
    text-align: center;
    color: #c5c8ce;
    font-size: 13px;
}
.cascade-add {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    border-top: 1px solid #e8eaec;
    color: #ff761d;
    font-size: 14px;
    cursor: pointer;
}
.cascade-add span {
    margin-left: 4px;
}
.cascade-add.disabled {
    color: #c5c8ce;
    cursor: not-allowed;
}
</style>